export default __webpack_public_path__ + "static/media/freshdesk.ee28a4d2.svg";